module.exports = __webpack_public_path__ + "9fc8ff7ca7ac144d739deb527d5b251d.woff2";